import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'app-training-page',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class TrainingPageComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    window.location.href = '/api/training/guide'
    this.router.navigate(['/app/meetings/past'])
  }
}
